import { render, staticRenderFns } from "./InheritancePropertyPage.vue?vue&type=template&id=cb645eb8&scoped=true"
import script from "./InheritancePropertyPage.vue?vue&type=script&lang=js"
export * from "./InheritancePropertyPage.vue?vue&type=script&lang=js"
import style0 from "./InheritancePropertyPage.vue?vue&type=style&index=0&id=cb645eb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb645eb8",
  null
  
)

export default component.exports